// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

window.parallaxVerticalMobAnimation = function parallaxVerticalMobAnimation() {
  const parallaxVerticalMobElsArr = document.querySelectorAll(
    '[data-parallax-vertical-mob-animation]'
  );

  if (parallaxVerticalMobElsArr.length && window.innerWidth <= 640) {
    parallaxVerticalMobElsArr.forEach((el) => {
      if (!el.classList.contains('is-init-parallax-vertical-mob-animation')) {
        el.classList.add('is-init-parallax-vertical-mob-animation');

        let startY = 100;
        let endY = 20;

        let startTrigger = 90;
        let endTrigger = 10;

        if (el.hasAttribute('data-parallax-vertical-mob-later-start')) {
          startTrigger = 70;
          endTrigger = 5;
          endY = 0;
        }

        const attrValue = el.getAttribute(
          'data-parallax-vertical-mob-animation'
        );

        let startPosition = 10;
        let endPosition = -20;

        if (attrValue) {
          const [startStr, endStr] = attrValue.split(',');
          startPosition = parseFloat(startStr) || 0;
          endPosition = parseFloat(endStr) || 0;
        }

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: el,
            start: `top-=${startY}vh ${startTrigger}%`,
            end: `bottom+=${endY}vh ${endTrigger}%`,
            scrub: 0.85,
            // markers: true,
            invalidateOnRefresh: true,
            onUpdate: (self) => {
              const progress = self.progress;

              el.style.transform = `translateY(${gsap.utils.interpolate(
                startPosition,
                endPosition,
                progress
              )}vh)`;
            },
          },
        });
      }
    });
  }
};

if (!document.querySelector('.bold-loader-new')) {
  parallaxVerticalMobAnimation();
}
